module.exports = __webpack_public_path__ + "static/img/mobile-steps.bb23eb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile-steps.svg
// module id = Tfei
// module chunks = 1